import logScope from 'log-scope'
import dataLog from 'services/dataLog'

const log = logScope('funnel')

const funnel = {
  id: '',
  steps: [],
  timestamps: [],
  isNewUser: true,
  isInitialized: false
}

funnel.init = async function (router) {
  if (this.isInitialized) {
    log.danger('Already initialized')
  }
  this.isInitialized = true

  if (location.hostname === 'localhost') {
    log.warning('Disable funnel for localhost')
    return
  }

  // New or returning user
  this.isNewUser = !localStorage.getItem('lastVisited')
  localStorage.setItem('lastVisited', +(new Date()))

  // Submit before unload
  try {
    const res = await dataLog.salesFunnel(this.getData())
    this.id = res.data.id || ''

    // Init step
    if (router && router.currentRoute && router.currentRoute.name) {
      await funnel.addStep(router.currentRoute.name)
    }

    log.success('Initializing', res)
  } catch (err) {
    log.error('Could not start sales funnel', err)
  }
}

funnel.addStep = async function (stepName) {
  this.steps.push(stepName)
  this.timestamps.push(+(new Date()))

  if (this.id === '') {
    log.danger('No ID to funnel')
    return
  }

  try {
    await dataLog.salesFunnelStep(this.getData())
    log.success('Added step: ' + stepName)
  } catch (err) {
    log.error('Could not add step', err)
  }
}

funnel.getData = function () {
  const data = {
    isNewUser: this.isNewUser,
    steps: this.steps,
    timestamps: this.timestamps,
    isLoggedIn: window.k$.isLoggedIn
  }

  if (this.id !== '') {
    data.id = this.id
  }

  return data
}

export default funnel
